module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TD-f939846fc3b9efe98c3140a3797e46cd.png";